<template>
    <div class="text-center">
        <v-progress-circular indeterminate color="primary" class="mr-3" v-if="loading" />
        <v-list subheader lines="two">
            <v-list-item
                v-for="(ba, i) in bankAccounts"
                :key="i"
                :class="getBankAccountItemClass(ba.id)"
                @click.stop="selectBankAccount(ba)"
                density="compact"
                rounded="xl"
                border
                lines="one"
            >
                <v-list-item-title>
                    {{ getBankAccountDisplayName(ba) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ ba.iban }}
                </v-list-item-subtitle>

                <template v-slot:append class="my-0">
                    <v-btn-icon
                        @click.stop="selectBankAccount(ba)"
                        color="primary"
                        :icon="
                            ba.id === bankAccountSelectedId
                                ? '$radio_button_checked'
                                : '$radio_button_unchecked'
                        "
                    >
                    </v-btn-icon>
                </template>
            </v-list-item>
        </v-list>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import COMPANY_BANK_ACCOUNTS from "../../graphql/bank/BankAccounts.gql";

import { BankAccount } from "../../../../types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component({
    emits: ["select-bank"],
})
export class BankAccountSelector extends Vue {
    @Prop({ default: "" }) readonly companyId: string;
    @Model({ default: undefined }) value: any;

    get loading() {
        if (this.$apollo.queries.bankAccounts) {
            return this.$apollo.queries.bankAccounts.loading;
        }
        return false;
    }

    get bankAccountSelectedId() {
        if (this.value) {
            return this.value.id;
        }

        return "";
    }

    @Apollo({
        query: COMPANY_BANK_ACCOUNTS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                console.log(data);
                if (data && data.bankAccounts && data.bankAccounts.length) {
                    // debugger
                    this.bankAccounts = data.bankAccounts;
                } else {
                    this.bankAccounts = [];
                }
            }
        },
    })
    bankAccounts: BankAccount[] = [];

    getBankAccountDisplayName(bankAccount) {
        return bankAccount.name;
    }

    selectBankAccount(bankAccount) {
        this.value = bankAccount;
        this.$emit("select-bank", bankAccount);
    }

    getBankAccountItemClass(bankAccountId) {
        let bankAccountClass = "oss-list-item mb-2";
        if (bankAccountId === this.bankAccountSelectedId)
            bankAccountClass += " oss-list-item-selected";
        return bankAccountClass;
    }
}

export default toNative(BankAccountSelector);
</script>
